import { ViolationStatus } from '../../api/rentalscape/__generated_types__/graphql';
import { SortType } from './types';

export const VIOLATION_STATUS_TO_USER_STRING_MAP: Record<
  ViolationStatus,
  string
> = {
  [ViolationStatus.Active]: 'Active',
  [ViolationStatus.Closed]: 'Closed',
  [ViolationStatus.Ignored]: 'Ignored',
  [ViolationStatus.Suspended]: 'Suspended',
  [ViolationStatus.UnderReview]: 'Under review',
  [ViolationStatus.Unknown]: 'Unknown',
};

export const HIDE_VIOLATION_STATUS_LIST: ViolationStatus[] = [
  ViolationStatus.Unknown,
];

export const VIOLATION_STATUS_DISABLED_LIST: ViolationStatus[] = [
  ViolationStatus.Closed,
  ViolationStatus.Unknown,
];

export const VIOLATION_TYPE_TO_USER_STRING_MAP: Record<string, string> = {
  check_information_violation: 'Information Check Violation',
  check_pool_violation: 'Pool Violation',
  check_self_contained: 'Self-Contained Usage Check Violation',
  contact_detail: 'Missing Contact details',
  emergency_contact_detail: 'Failure to Provide Emergency Contact Information',
  exempted_zones_needs_tot_violation: 'Needs TOT & STR Exempted',
  hoe_check: 'Claiming HOE with active rental ad',
  license_num_bedrooms_violation: 'Unlicensed Bedrooms',
  license_occ_violation: 'Excess Occupancy',
  license_violation: 'License Violation',
  max_booking_events: 'Exceeded Maximum Booking Events',
  max_nights: 'Exceeded Maximum Rented Days',
  max_nights_current_year: 'Exceeded Maximum Rented Days (Current Year)',
  minimum_advertised_stay_violation: 'Minimum Advertised Stay Violation',
  minimum_advertised_stay_violation_ltr:
    'Minimum Advertised Stay Violation (LTR)',
  minimum_booked_stay_violation: 'Minimum Booked Stay Violation',
  minimum_booked_stay_violation_ltr: 'Minimum Booked Stay Violation (LTR)',
  multiple_units: 'Multiple ads for same apn on one listing site',
  non_residential_violation: 'Non-residential usage advertised',
  occupancy_violation: 'Excess Occupancy',
  region_oriented_has_str_active_needs_tot_violation:
    'STR Active: Cancel STR or Needs TOT Cert',
  region_oriented_has_tot_active_needs_str_violation:
    'TOT Active: Cancel TOT or Needs STR Permit',
  region_oriented_has_tot_needs_str_violation: 'Has TOT & Needs STR',
  region_oriented_needs_tot_has_str_violation: 'Needs TOT & Has STR',
  region_oriented_needs_tot_needs_str_violation: 'Needs TOT & Needs STR',
  residential_violation: 'Non-Primary Residence Utilized as an STR',
  restricted_rental_types_in_ad: 'Restricted Rental Types Advertised',
  self_check_in_violation: 'Self Check-in Violation',
  stay_violation: 'Stay Violation',
  stay_violation_ltr: 'Stay Violation (LTR)',
  stay_violation_nevada: 'Stay Violation (Nevada Specific)',
  stay_violation_placer: 'Stay Violation (Placer Specific - Suspended Permits)',
  stay_violation_tuolumne: 'Stay Violation (Tuolumne Specific)',
  str_ban_violation: 'STR Ban Violation',
  str_exists: 'Current or Previous STR',
  str_license_exists: 'Operating with a Permit',
  structure_violation: 'ADU Utilized as an STR',
  tot_violation: 'TOT Violation',
};

// TODO DECK-26332 Remove/replace with backend types
export const SortModeByField: Record<string, Record<SortType, string>> = {
  rawType: {
    asc: 'RAW_TYPE_ASC',
    desc: 'RAW_TYPE_DESC',
  },
  status: {
    asc: 'STATUS_ASC',
    desc: 'STATUS_DESC',
  },
  created: {
    asc: 'CREATED_ASC',
    desc: 'CREATED_DESC',
  },
};

export const ITEMS_PER_PAGE = 100;
